import type { McaDisplayAttribute } from '../graphql/types';
import { Recurrency, MerchantCashAdvanceStatus, Syndication } from '../graphql/types';

export enum McaDisplayAttributeType {
  REFI_LEVEL = 'REFI_LEVEL',
  STACK_LEVEL = 'STACK_LEVEL',
  REVERSE_FUNDING = 'REVERSE_FUNDING'
}

export const NotPayingStatuses = [
  MerchantCashAdvanceStatus.NotPaying,
  MerchantCashAdvanceStatus.Paused,
  MerchantCashAdvanceStatus.PrepLegal,
];

export const NotPayingAndResumedStatuses = [
  ...NotPayingStatuses,
  MerchantCashAdvanceStatus.Resumed,
];

export function recurrencyTitle(recurrency: Recurrency) {
  if (recurrency.integration.type === 'ACH_PROC') {
    return `Schedule Name: ${recurrency.referenceMca}${
      recurrency.referenceRecurrence ? '; Entry Description: ' + recurrency.recurrenceNumber : ''
    }`;
  }

  if (recurrency.integration.type === 'GO_ACH_BOT' || recurrency.integration.type === 'GO_ACH') {
    return `Client Name: ${recurrency.referenceRecurrence || recurrency.referenceMca}; Bank Account Name: ${recurrency.referenceMca}`;
  }

  return `ACH Processor Data: "${recurrency.referenceMca}"`;
}

export function isUserFunderSyndicator(syndications?: Syndication[] | null, userId?: string | null): boolean {
  if (!syndications || !userId) return false;
  return syndications.some((s) => s.type === 'FUNDER' && s.userId === userId);
}

export function parseMcaDisplayTiers(displayAttributes: string[], attributeCatalog: McaDisplayAttribute[]) {
  const normalizeKey = (value: string): string => value.trim().toUpperCase();
  const findRow = (key: string) => attributeCatalog.find((r) => normalizeKey(r.key) === key);

  const keys = (displayAttributes || []).map(normalizeKey).filter(Boolean);
  const refiKey = keys.find((k) => k[0] === 'R') || null;
  const stackKey = keys.find((k) => k[0] === 'S') || null;
  const reverseFunding = keys.includes('V');

  const primaryKey = refiKey || stackKey || (reverseFunding ? 'V' : '');
  const primaryRow = primaryKey ? findRow(primaryKey) : null;

  return {
    refi: refiKey ? +refiKey.slice(1) : null,
    stack: stackKey ? +stackKey.slice(1) : null,
    reverseFunding,
    primaryType: (primaryRow?.type || null) as McaDisplayAttributeType | null
  };
}